import * as iframeSelectors from '../../Iframe/selectors'
import * as starredSelectors from '../../Dashboard/selectors'
import { AppState, Dispatch } from '../../../types'
import { EventProps, default as MyCustomDashboard, ValueProps, ExternalProps } from './MyCustomDashboard'
import { connect } from 'react-redux'
import builtInSelectors from '../../BuiltInDashboard/selectors'
import { selectors as authSelectors } from '../../../lifecycle/auth'
import { autoRefreshChange, rangeChange } from '../../BuiltInDashboard/actions'
import { TimeRange } from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt'
import * as actions from '../../Dashboard/actions'
import { AutoRefreshFrequency } from '@mulesoft/monitoring-center-components/lib/components/Toolbar/AutoRefresh/model'
import { notifyEvent } from '../../Iframe/actions'

const mapProps = (state: AppState, ownProps: ExternalProps): ValueProps => ({
  ...ownProps,
  iframeState: iframeSelectors.getState(state),
  isTitanium: authSelectors.isMonitoringCenterPremium(state),
  time: builtInSelectors.range(state),
  autoRefresh: builtInSelectors.autoRefresh(state),
  starred: starredSelectors.isStarred(state),
  hasEditRole: authSelectors.hasEditRole(state)
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  notifyEvent: (type: string, event: string, detail: any) => dispatch(notifyEvent(type, event, detail)),
  rangeChange: (range: TimeRange) => dispatch(rangeChange(range)),
  changeDashboardStarred: (starred: boolean) => dispatch(actions.changeDashboardStarred(starred)),
  onAutoRefreshToggle: (checked: boolean, frequency: AutoRefreshFrequency) => dispatch(autoRefreshChange(checked, frequency))
})

export default connect(mapProps, mapDispatch)(MyCustomDashboard)
